<main [@fadeInOut] class="container-fluid" role="main" id="main-heading" tabindex="0">
  <div class="col-sm-11 mx-auto d-flex flex-column  main-heading-div">
    <div class="row">
      <h1 class="mt-3 ps-3">Export Data</h1>
    </div>

    <div class="row">
      <div class="mt-4 ps-3 title-div" *appHideByAccess="permissionsConst.CreateEditExportTemplate">
        <a href="javascript:void(0);" (click)="showAttrDialog()" role="button"
          aria-label="Create New Custom Template"><i class="fa fa-plus-circle fa-lg"></i>
          <span class="ms-2 larger-title-font-size">Create New Custom Template</span>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 mt-4 mb-3">
        <span
          aria-label="Templates - Edit or delete existing export templates. Run templates to build export files for download."
          class="bold ms-2">Templates</span><span> - Edit or delete existing export templates. Run templates to build
          export files for download.</span>
      </div>
      <div class="ms-2">
        <span aria-label="Results Returned">Results Returned:<span *ngIf="templates.length >= 0; else emptyBadge" class="badge  warning-background badge-bottom-margin">
            {{templates.length}}
          </span> records</span>

        <ng-template #emptyBadge>
          <span class="badge warning-background badge-bottom-margin loading-dots">
            <span>.</span><span>.</span><span>.</span>
          </span>
        </ng-template>
      </div>
    </div>
    <div class="row mb-4" role="region" aria-label="Templates grid">
      <div class="exports-div">
        <div class="col-sm-12 header sticky-header d-flex flex-row ps-1 mb-3" role="grid" aria-colcount="7">
          <div class="col-sm-2">
            <span aria-label="Template Name" role="columnheader">Template Name</span>
          </div>
          <div class="col-sm-1">

          </div>
          <div class="col-sm-2">
            <span aria-label="Modified By" role="columnheader">Modified By</span>
          </div>
          <div class="col-sm-2">
            <span aria-label="Modified Date/Time" role="columnheader">Modified Date/Time</span>
          </div>
          <div class="col-sm-2">
            <span aria-label="Created by" role="columnheader">Created by</span>
          </div>
          <div class="col-sm-2">
            <span aria-label="Created Date/Time" role="columnheader">Created Date/Time</span>
          </div>
          <div class="col-sm-1" *appHideByAccess="permissionsConst.ExecuteExportDownloadTemplate">
            <span aria-label="Action" role="columnheader">Action</span>
          </div>
        </div>

        <ng-container *ngIf="templates && templates.length; else emptyTemplatesSection">
          <div class="col-sm-12 d-flex d-flex-row mt-2 ps-1" *ngFor="let item of templates">
            <div class="col-sm-2 mx-auto breakAll">
              <span class="grid-content" role="gridcell"
                aria-label="cell of Template Name column">{{item.exportTemplateName}}</span>
            </div>
            <div class="col-sm-1 px-2">
              <div class="col-sm-12 d-flex flex-row">
                <div class="mx-auto" *appHideByAccess="permissionsConst.CreateEditExportTemplate"
                  aria-label="cell of Action column">
                  <a title="Edit Template" alt="Edit Template" href="javascript:void(0)"
                    (click)="showAttrDialog(item.exportTemplateId)" class="editLink mx-auto" role="button"
                    aria-label="Edit Template">
                    <i class="fal fa-edit fa-lg"></i>
                  </a>
                </div>
                <div class="mx-auto" *appHideByAccess="permissionsConst.DeleteExportTemplate"
                  aria-label="cell of Action column">
                  <a href="javascript:void(0)" title="Delete Template" alt="Delete Template"
                    (click)="showDeleteConfirmation(item.exportTemplateId, item.exportTemplateName)" role="button"
                    aria-label="Delete Template" class="mx-auto">
                    <i class="fal fa-trash-alt fa-lg"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="col-sm-2">
              <span class="grid-content" role="gridcell"
                aria-label="cell of Change User column">{{item.changeUser}}</span>
            </div>
            <div class="col-sm-2">
              <span class="grid-content" role="gridcell" aria-label="cell of Change Date column">{{item.changeDateTime | date : 'MM/dd/yyyy hh:mm a'}}</span>
            </div>
            <div class="col-sm-2">
              <span class="grid-content" role="gridcell"
                aria-label="cell of Create User column">{{item.createUser}}</span>
            </div>
            <div class="col-sm-2">
              <span class="grid-content" role="gridcell"
                aria-label="cell of Create Date/Time column">{{item.createDateTime | date : 'MM/dd/yyyy hh:mm a'}}</span>
            </div>
            <div class="col-sm-1" *appHideByAccess="permissionsConst.ExecuteExportDownloadTemplate">
              <button class="btn btn-sm btn-primary" (click)="runTemplate(item.exportTemplateId)"
                aria-label="Run Template" alt="Run Template" role="gridcell" aria-label="cell of Action column">Run
                Template</button>
            </div>
          </div>
        </ng-container>
        <ng-template #emptyTemplatesSection>
          <span class="grid-content" aria-label="No Templates to display">No Templates to display. <a
              href="javascript:void(0);" (click)="showAttrDialog()"
              *appHideByAccess="permissionsConst.CreateEditExportTemplate" role="button"
              aria-label="Create New Custom Template">Create New Custom Template.</a></span>
        </ng-template>
      </div>
    </div>

    <div class="row d-flex flex-column" role="region" aria-label="Generated files grid">
      <div class="col-sm-12 mt-4 mb-3 ps-3">
        <span class="bold">Files for Download</span> <span> - File build times may vary. Large exports may require
          multiple files. Click filenames as they appear below to download the export.</span>
      </div>
      <div class="col-sm-12 ps-3">
      <span aria-label="Results Returned">Results Returned:<span *ngIf="tasksCount >= 0; else emptyBadge" class="badge  warning-background badge-bottom-margin">
          {{tasksCount}}
        </span> records</span>
      </div>
      <ng-template #emptyBadge>
        <span class="badge warning-background badge-bottom-margin loading-dots">
          <span>.</span><span>.</span><span>.</span>
        </span>
      </ng-template>
      <div class="col-sm-12 ps-3">

        <ejs-tooltip #tooltipObj id="tooltipObj" (beforeRender)="tooltipValue($event)" [enableHtmlParse]="false"
          target=".e-ellipsistooltip">

          <ejs-grid id="exportedFiles" name="exportedFiles" #grid [dataSource]='tasks' allowPaging="true"
            class="grid-striped" pageSizes="true | []" [pageSettings]="pageOptions" [filterSettings]="filterSettings"
            [showColumnChooser]="false" [toolbar]="toolbar" (toolbarClick)='toolbarClick($event)' allowSorting="true"
            allowFiltering="true" allowScrolling="true" [allowReordering]="false"
            (dataStateChange)="dataStateChange($event)" (actionComplete)="complete($event)"
            (actionBegin)="actionBegin($event)" (dataBound)="dataBound($event)" (created)="created($event)"
            (actionFailure)="failure($event)" (load)="load()" [allowSelection]="true"
            [selectionSettings]="selectionOptions" height="280"
            [sortSettings]='sortSettings'>
            <e-columns>
              <e-column type='string' field='fileName' headerText='File Name' width='200' isPrimaryKey='true'
                clipMode='EllipsisWithTooltip'>

                <ng-template #template let-data>
                  <a href="javascript:void(0)" class="pointer" title="Download File"
                    (click)="downloadExportedFile(data.fileName, data.filePath)"
                    *ngIf="data.taskStatus.toLowerCase() === 'completed'; else plainTextTemplate">
                    <i class="fal fa-download" aria-hidden="true"></i>
                    <span class="padding-left-5">{{data.fileName}}</span>
                  </a>
                  <ng-template #plainTextTemplate>
                    <div class="status-block small-loading">
                      <i class="padding-left-25">Not Available</i>
                    </div>
                  </ng-template>
                </ng-template>
              </e-column>
              <e-column type='string' field='templateName' headerText='Template Used' width='250'
                clipMode='EllipsisWithTooltip'>
              </e-column>
              <!-- <e-column type='string' field='format' headerText='Format' width='250' clipMode='EllipsisWithTooltip'>
                </e-column> -->
              <e-column type='string' field='taskStatus' headerText='Status' width='250' clipMode='EllipsisWithTooltip'>
                <ng-template #template let-data>
                  <span class="tooltip-span"
                    (mouseover)="showTooltip($event, 'file status')">{{data["taskStatus"]}}</span>
                </ng-template>
              </e-column>
              <e-column type='string' field='createUser' headerText='Created By' width='250'
                clipMode='EllipsisWithTooltip'>
              </e-column>
              <e-column type='date' field='createDateTime' headerText='Created Date/Time' width='210'
                [format]='formatOptions' clipMode='EllipsisWithTooltip'>
              </e-column>
            </e-columns>
          </ejs-grid>
        </ejs-tooltip>
      </div>
    </div>

    <div class="col-sm-12">
      <div class="col-sm-11 center-block">
        <app-attributes-modal #attrModal [attributes]='attributes' [properties]='properties'
          [editTemplateId]='editTemplateId' [templates]='templates' class="hidden" (modified)="reloadTemplates()">

        </app-attributes-modal>
      </div>
    </div>

  </div>
  <!-- Delete confirmation dialog -->
  <ejs-dialog #deleteDialog id="deleteDialog" [isModal]='isModal' [animationSettings]='animationSettings'
    [closeOnEscape]='true' [width]='modalDeleteWidth' [position]='modalPosition' [visible]='modalVisible'
    [showCloseIcon]='false' (close)='onDeleteDialogClose($event)' [height]='modalHeight'
    (overlayClick)="onDeleteOverlayClick()" [hidden]='!modalVisible'>

    <div class="card">
      <div class="card-header bg-primary">
        <h4 class="card-title">Warning</h4>
      </div>
      <div class="card-body">
          <div class="px-2 my-2 breakAll">
            Delete Export Template <span class="bold">"{{templateToDeleteName}}"</span>?
          </div>

          <div class="px-2 my-2 breakAll">
            This cannot be undone.

        </div>
      </div>
      <div class="card-footer mb-3">
        <button id="btnCancel" class="btn btn-default dialogButton" (click)="deleteCancel($event)"
          data-ripple="true">Cancel</button>

        <button id="btnDelete" class="btn btn-primary dialogButton" (click)="deleteConfirm($event)"
          data-ripple="true">Confirm</button>
      </div>
    </div>
  </ejs-dialog>
</main>

